import { IApiResponse } from '@interfaces/module.interface';
import {
  IGeneralDetailsInterface,
  IStationDetailsInterface,
} from '@modules/point-of-sale/interface/bo-interface/general-details.interface';
import { api } from '@services/api';
import { handleError } from '@utils/api-error-handling';
// import { encryptPayload } from '@utils/security';

// #region API Endpoints
export const generalSettingsAPI = api
  .enhanceEndpoints({
    addTagTypes: [
      'GeneralSettingsDetailsList',
      'GeneralSettingsDetails',
      'POSStationDetails',
    ],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllGeneralSettingsList: builder.query({
        query: () => 'stations',
        providesTags: ['GeneralSettingsDetailsList'],
        async onQueryStarted(_arg, { queryFulfilled }) {
          await queryFulfilled;
        },
        transformResponse: (response: IApiResponse<IGeneralDetailsInterface>) =>
          response?.data,
        forceRefetch: () => true,
        transformErrorResponse: (baseQueryReturnValue) =>
          handleError(baseQueryReturnValue),
      }),
      getGeneralSettingsWithParams: builder.query({
        query: (params?: string | null) => {
          return `stations/${params}`;
        },
        providesTags: ['GeneralSettingsDetails'],
        async onQueryStarted(_arg, { queryFulfilled }) {
          await queryFulfilled;
        },
        transformResponse: (response: IApiResponse<IGeneralDetailsInterface>) =>
          response?.data,
        forceRefetch: () => true,
        transformErrorResponse: (baseQueryReturnValue) =>
          handleError(baseQueryReturnValue),
      }),
      getStationDetailsWithParams: builder.query({
        query: (params?: string | null) => {
          return `stations/${params}/details`;
        },
        providesTags: ['POSStationDetails'],
        async onQueryStarted(_arg, { queryFulfilled }) {
          await queryFulfilled;
        },
        transformResponse: (response: IApiResponse<IStationDetailsInterface>) =>
          response?.data,
        forceRefetch: () => true,
        transformErrorResponse: (baseQueryReturnValue) =>
          handleError(baseQueryReturnValue),
      }),
    }),
  });
// #endregion API Endpoints

// #region Export Hooks
export const {
  useGetAllGeneralSettingsListQuery,
  useGetGeneralSettingsWithParamsQuery,
  useGetStationDetailsWithParamsQuery,
} = generalSettingsAPI;
// #endregion Export Hooks
